import { config } from '../../../../enviroment';
import {apolloClientService} from '../../../../services/apollo-client'

export const usageService = {
    getEnergyPlansDetails,
    getEnergyDetailsPage
};

 async function getEnergyPlansDetails(saId, accountId){
  let bearer = localStorage.getItem("bearer");
  let personId = "";
  let tenantCode = config.constants.BASE_TENANT_CODE;
  if (bearer) {
    bearer = JSON.parse(bearer);
    personId = bearer.personId;
  }
    let APIquery =`{ 
        getEnergyPlans(input: {tenantCode:"`+tenantCode+`",accountId:"`+accountId+ `",    
            saId:"`+saId+ `",    
            personId:"`+personId+`"}){    
                saId 
                description  
                serviceType  
                serviceTypeDescription  
                isLowCostPlanExist  
                rateSchedule  
                rateScheduleDescription 
                isCurrentRateSchedule 
                currency  
                calculatedAmount  
                bestFor 
                priceHighest 
                rates {  
                    rateSchedule  
                    rateScheduleDescription 
                    isCurrentRateSchedule 
                    currency  
                    calculatedAmount    
                    differenceAmount  
                    bestFor
                    priceHighest
                    isLowCostPlan
                    isLowestCostRatePlan
  
                } 
            }    
        }`;
        let headers={
            accountId: accountId,
            saId: saId
          }   
    return await apolloClientService.ApolloClientgqlsUsage(APIquery,headers);
}

async function getEnergyDetailsPage(saId, accountId,rateSchedule){
    let bearer = localStorage.getItem("bearer"); 
    let tenantCode = config.constants.BASE_TENANT_CODE;
    if (bearer) {
      bearer = JSON.parse(bearer);
    }
      let APIquery =`{ 
          getEnergyPlanDetails(input: {
              tenantCode:"`+tenantCode+`",
              rateSchedule:"`+rateSchedule+`"}) {
                  rateSchedule
                  currencyCd
                  uom
                  units
                  tables {
                      title
                      data {
                          key
                          value
                      }
                  }
              }          
      }`;
          let headers={
              accountId: accountId,
              saId: saId
            }   
      return await apolloClientService.ApolloClientgqlsUsage(APIquery,headers);
  }